var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86792 19.7105C9.46961 19.7105 9.13597 19.5755 8.867 19.3056C8.59708 19.0366 8.46213 18.703 8.46213 18.3047V11.2757H1.43314C1.03483 11.2757 0.700721 11.1407 0.430808 10.8708C0.161832 10.6018 0.0273438 10.2682 0.0273438 9.86988C0.0273438 9.47157 0.161832 9.13746 0.430808 8.86754C0.700721 8.59857 1.03483 8.46408 1.43314 8.46408H8.46213V1.43509C8.46213 1.03678 8.59708 0.702674 8.867 0.432761C9.13597 0.163785 9.46961 0.0292969 9.86792 0.0292969C10.2662 0.0292969 10.6003 0.163785 10.8703 0.432761C11.1392 0.702674 11.2737 1.03678 11.2737 1.43509V8.46408H18.3027C18.701 8.46408 19.0347 8.59857 19.3036 8.86754C19.5735 9.13746 19.7085 9.47157 19.7085 9.86988C19.7085 10.2682 19.5735 10.6018 19.3036 10.8708C19.0347 11.1407 18.701 11.2757 18.3027 11.2757H11.2737V18.3047C11.2737 18.703 11.1392 19.0366 10.8703 19.3056C10.6003 19.5755 10.2662 19.7105 9.86792 19.7105Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d5bf7e3aa03c6b122381711fd00dfb45.svg";
export { ForwardRef as ReactComponent };